import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../layout/Navbar";
import Header from "../../layout/Header";
import Main from "../Home/Main";
import CityView from "./CityView";
import Footer from "../../layout/Footer";
import SEO, { getSEOData } from "../../components/SEO";
import NotFound from "../NotFound";
import { cityPath } from "../../utils/urls";

function Cities() {
  const { cityName } = useParams();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setNotFound(false);
  
    const formatCityName = (slug) => {
      if (!slug) return "";
      return slug
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };
  
    const formatted = formatCityName(cityName);
  
    // ✅ store prefill for From input
    if (formatted) {
      localStorage.setItem("pulpit_prefill_from_city", formatted);
    }
  }, [cityName]);  

  const formatCityName = (slug) => {
    if (!slug) return "City";
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formattedCityName = formatCityName(cityName);
  const seo = getSEOData("city", formattedCityName);

  // ✅ If invalid city => show ONLY 404 page
  if (notFound) return <NotFound />;

  return (
    <div className="cities">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonical={cityPath(cityName)}
      />
      <Navbar page="home" />
      {/* <Header /> */}
      <Main />
      <CityView onNotFound={setNotFound} />
      <Footer />
    </div>
  );
}

export default Cities;
